import React, { FC, memo } from 'react';
import FormikSelect from '@minecraft.formik-select';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { getOptionsWithEmptyOption } from '../../../shared/utils';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = FilterData;

const AnimalSize: FC<Props> = ({ name, label }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.assets);

  return (
    <>
      <Label>{label}</Label>
      <FormikSelect name={name} size="small" options={getOptionsWithEmptyOption(getMatchedSearchOptions(name))} />
    </>
  );
};

export default memo(AnimalSize);
